import { Icon } from "./Icon.tsx";

/** ToolsMenu.tsx's own "trace upstream" action icon — the vertical mirror of TraceDownstreamIcon.tsx: one point branching back into its own two source nodes, arrowhead pointing up (against the flow) to read as "trace back to the source" rather than "flow downstream". */
export function TraceUpstreamIcon() {
  return (
    <Icon>
      <circle cx="6" cy="19" r="1.6" />
      <circle cx="18" cy="19" r="1.6" />
      <path d="M6 17.5 L12 12 M18 17.5 L12 12 M12 12 L12 7 M8.5 9.5 L12 6 L15.5 9.5" />
    </Icon>
  );
}
